export default "__VITE_ASSET__64Azlo6T__"